export default __webpack_public_path__ + "static/media/arrow_left_blue.e43d9862.svg";